import { AddressInput } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const updateFacilityMutationAtom = createMutationAtomFactory(
  'settings.facilityUpdate',
  (params: {
    id: string;
    facilityName?: string;
    facilityType?: string;
    facilityGroupId?: string | null;
    timezone?: string;
    address?: AddressInput;
    phone?: string;
    email?: string;
  }) => ({
    coreFacilityUpdate: {
      __args: {
        id: params.id,
        input: {
          facilityName: params.facilityName,
          facilityType: params.facilityType,
          facilityGroupId: params.facilityGroupId,
          timezone: params.timezone,
          address: params.address,
          phone: params.phone,
          email: params.email,
        },
      },
      id: true,
    },
  }),
);
